import React, { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { message } from 'antd';

import { Ajax } from 'components/Ajax';
import { T } from 'components/Translations';
import { ApiUrl } from 'project/Defines.js';
import ListView from 'Shared/ListView';
import { COLUMN_TYPE } from 'Shared/ListView/helper';
import { EVENT_NAME, dispatchCustomEvent } from 'project/utilities';
import { closePopup } from '~/store/actions';

/**
 * @exports FamillySkillsPickup
 */
export default function FamillySkillsPickup(props) {
    const { data } = props;
    const dispatch = useDispatch();
    const [selectedRows, setSelectedRows] = useState([]);
    const [updating, setUpdating] = useState(false);

    const columnConfig = [
        {
            text: 'text.name',
            field: 'nom',
            type: COLUMN_TYPE.TEXT
        }
    ];

    const updateData = useCallback(() => {
        setUpdating(true);
        Ajax.post({
            url: ApiUrl.FamillySkillAdd,
            data: {
                famille_uuid: data.ID,
                selected: selectedRows
            },
            success: function (response) {
                setUpdating(false);
                if (!response.HasError) {
                    message.success(<T args={[response.AddedCount || 'No']}>message.skills_were_added</T>);
                    dispatchCustomEvent(EVENT_NAME.FAMILLY_SKILL_LIST_UPDATE, { action: "update" });
                    dispatch(closePopup("changeFamillySkills"));
                } else {
                    message.error(response.message)
                }
            },
            error: function (response) {
                setUpdating(false);
                message.error(<T>{response.message}</T>)
            }
        })
    }, [selectedRows, data.ID, dispatch]);

    return (<>
        <ListView
            search={{ field: 'nom' }}
            isSimple
            {...props}
            skipNewButton
            //noPaging
            tableLayout="Fixed"
            staticFilter={{ famille_uuid: data.ID }}
            rowSelection={{
                selectedRowKeys: selectedRows,
                onChange: (selectedRowKeys) => {
                    setSelectedRows(selectedRowKeys);
                }
            }}
            onLoaded={(data, sorts) => { // NOSONAR
                return data;
            }}
            columnConfig={columnConfig}
            apiUrl={ApiUrl.SkillList}

        />
        {
            <toolbar>
                <wrap>
                    <action right=''>
                        <div 
                            onClick={updateData} 
                            className='button' 
                            {...(updating || selectedRows.length === 0) ? { disabled: 'disabled' } : {}}
                        ><icon>save</icon><T>text.add</T></div>
                    </action>
                </wrap>
            </toolbar>
        }
    </>);
}